export default "<p>mynotifications works!</p>\n"